/*
 * @Author: 南岸有归
 * @Date: 2020-02-24 09:24:27
 * @LastEditTime: 2020-04-10 17:51:17
 * @LastEditors: 南岸有归
 * @Description: 
 * @FilePath: \cloud_frontend\src\api\graphs.js
 * @
 */
import http from '@/axios/http'
import { getuser_id } from "@/localStorage/localStorage";
//获取所有分组，分页查询所有设备
export function getGroupList(allDevice = 0, allGroup = 0, offset = 1, limit = 10) {
    const data = {
        allDevice: allDevice,
        allGroup: allGroup,
        user_id: getuser_id(),
        offset: offset,
        limit: limit
    }
    return http({
        url: '/api/device/getGroupList',
        method: 'post',
        data
    })
}
//通过分组id与设备序列号搜索所有
export function querySNs(gid, key, offset = 1, limit = 10) {
    const data = {
        gid: gid,
        limit: limit,
        offset: offset,
        key: key,
        allDevice: 1
    }
    return http({
        url: '/api/device/querySNs',
        method: 'post',
        data
    })
}

//通过分组id获取分组下的设备
export function GroupDevices(gid,queryType, limit, offset, sn){
    return http({
        url: '/api/device/group/devices',
        method: 'post',
        data: { gid, queryType, limit, offset, sn }
    })
}

//获取一二三级分组
export function getAddLevel3Group(pid) {
    return http({
        url: '/api/device/getAddLevelGroup',
        method: 'post',
        data:{pid}
    })
}
